module.exports = __webpack_public_path__ + "static/media/pr-13.6ed5e825.jpeg";